<template>
    <div class="sticky">
        <el-button @click="$emit('openFilters')">
            {{ $trans('web_search.filters.filter') }}
            <span style="padding-right: 14px;">
                <img src="/media/images/filter_icon.svg" style="position: relative; width: 16px; top: 3px; padding-left: 5px;">
            </span>
        </el-button>
        <el-button class="search-btn" @click="$emit('openSearcher')">
            {{ $trans('web_search.start_search') }}
            <el-icon class="el-icon--right"><SearchIcon /></el-icon>
        </el-button>
    </div>
</template>

<script>
import { Search as SearchIcon } from '@element-plus/icons-vue'

export default {
    components: {
        SearchIcon,
    },
}
</script>

<style>

.sticky {
    display: none;
}


@media only screen and (max-width: 800px) {
    .sticky {
        display: block;
        background-color: #41abc4;
        color: #fff;
        position: fixed;
        bottom: 0px;
        padding: 1em 0;
        width: 100vw;
        text-align: center;
        z-index: 1;
    }

    .sticky .el-button {
        border-radius: 25px;
        min-width: 160px;
    }

    .sticky .el-button.search-btn .el-icon svg {
        transform: scaleX(-1);
    }
}
</style>
